import '../vendor';
import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';

import './text-page/text-sl'


// WEBPACK FOOTER //
// ./src/js/pages/text-page.js